import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MostaContextMenu',
  props: {
    visible: { type: Boolean },
    position: {},
    minWidth: { default: 200 },
    menuClass: { default: '' },
    backdropCursor: { default: 'default' },
    disableBackdropPointer: { type: Boolean, default: false }
  },
  emits: ["close", "menuEnter", "menuLeave"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const menuStyle = computed(() => ({
  top: props.position?.top ?? '0px',
  left: props.position?.left ?? '0px',
  minWidth: `${props.minWidth}px`,
}));

const backdropStyle = computed(() => ({
  cursor: props.backdropCursor,
  pointerEvents: props.disableBackdropPointer ? 'none' : 'auto',
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mosta-context-menu-backdrop",
          style: _normalizeStyle(backdropStyle.value),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('close')))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(['mosta-context-menu', _ctx.menuClass]),
            style: _normalizeStyle(menuStyle.value),
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
            onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (emit('menuEnter'))),
            onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (emit('menuLeave')))
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 38)
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})